import IndexPage from "./IndexPage";

const keyName = 'OfficePage';
export default class OfficePage extends IndexPage {
}
